import createReactComponent from '../createReactComponent';
export default createReactComponent('mood-search', 'IconMoodSearch', [
  ['path', { d: 'M21 12a9 9 0 1 0 -9 9', key: 'svg-0' }],
  ['path', { d: 'M9 10h.01', key: 'svg-1' }],
  ['path', { d: 'M15 10h.01', key: 'svg-2' }],
  ['path', { d: 'M9.5 15c.658 .672 1.56 1 2.5 1', key: 'svg-3' }],
  ['path', { d: 'M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-4' }],
  ['path', { d: 'M20.2 20.2l1.8 1.8', key: 'svg-5' }],
]);
